import { Link, Grid, Typography, Hidden } from '@mui/material';
import union1 from '../../assets/pictures/unia1.jpg';
import union2 from '../../assets/pictures/unia2.jpg';
import colors from '../../assets/colors';
import texts from '../../assets/texts';

export default function Copyright() {
  return (
    <Grid container direction="column" alignItems="center">
      <Grid item>
        <Typography
          variant="subtitle2"
          align="center"
          sx={{
            color: colors.agroweGreen,
            letterSpacing: '0.1px',
            fontSize: 14,
          }}
        >
          {texts.copyright}
        </Typography>
      </Grid>
      <Hidden lgUp>
        <Grid
          container
          item
          xs={12}
          alignItems="center"
          justifyContent="center"
          spacing={0}
        >
          <Grid
            container
            alignItems={'center'}
            justifyContent={'center'}
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
          >
            <img src={union1} alt={'UE support'} height={'80%'} />
          </Grid>
          <Grid
            container
            alignItems={'center'}
            justifyContent={'center'}
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
          >
            <img src={union2} alt={'UE support'} height={'80%'} />
          </Grid>
        </Grid>
      </Hidden>
      <Hidden lgDown>
        <Grid
          container
          item
          xs={12}
          alignItems="center"
          justifyContent="center"
          spacing={0}
        >
          <Grid
            container
            alignItems={'flex-end'}
            justifyContent={'flex-end'}
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
          >
            <img src={union1} alt={'UE support'} height={'80%'} />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <img src={union2} alt={'UE support'} height={'80%'} />
          </Grid>
        </Grid>
      </Hidden>
      <Grid item>
        <Typography variant="overline" color="textSecondary" align="center">
          {'Copyright © '}
          <Link color="inherit" href="http://agrowe.pl">
            AgroWe.pl
          </Link>{' '}
          {new Date().getFullYear()}
        </Typography>
      </Grid>
    </Grid>
  );
}
